import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AideModule } from '../aide/aide.module';
import { ActualiteCardComponent } from '../modules/actualite/actualite-card/actualite-card.component';
import { ActualiteCarouselComponent } from '../modules/actualite/actualite-carousel/actualite-carousel.component';
import { ActualiteViewComponent } from '../modules/actualite/actualite-view/actualite-view.component';
import { VendorsModule } from '../modules/vendors.module';
import { PipesModule } from '../pipes/pipes.module';
import { CategorieHierarchiqueDropdownComponent } from './categorie-hierarchique-dropdown/categorie-hierarchique-dropdown.component';
import { FonctionDropdownComponent } from './fonction-dropdown/fonction-dropdown.component';
import { IndicateurDropdownComponent } from './indicateur-dropdown/indicateur-dropdown.component';
import { ProgressionComponent } from './progression/progression.component';
import { ProgressionService } from './progression/progression.service';
import { ReadMoreHtmlComponent } from './read-more-html/read-more-html.component';
import { SelectEtablissementComponent } from './select-etablissement/select-etablissement.component';
import { SelectSiteComponent } from './select-etablissement/select-site.component';
import { StatutEmploiDropdownComponent } from './statut-emploi-dropdown/statut-emploi-dropdown.component';
import { StringListEditorComponent } from './string-list-editor/string-list-editor.component';
import { TypeActionDropdownComponent } from './type-action-dropdown/type-action-dropdown.component';
import { DisplayTypeMediaComponent } from './upload/display-type-media.component';
import { UploadListHorizontalComponent } from './upload/upload-list-horizontal.component';
import { UploadComponent } from './upload/upload.component';
import { UploadsComponent } from './upload/uploads.component';
import { UtilisateurDropdownComponent } from './utilisateur-dropdown/utilisateur-dropdown.component';

const components = [
  ActualiteCardComponent,
  ActualiteCarouselComponent,
  ActualiteViewComponent,
  CategorieHierarchiqueDropdownComponent,
  DisplayTypeMediaComponent,
  FonctionDropdownComponent,
  IndicateurDropdownComponent,
  ProgressionComponent,
  ReadMoreHtmlComponent,
  SelectEtablissementComponent,
  SelectSiteComponent,
  StatutEmploiDropdownComponent,
  StringListEditorComponent,
  TypeActionDropdownComponent,
  UploadComponent,
  UploadListHorizontalComponent,
  UploadsComponent,
  UtilisateurDropdownComponent
];

@NgModule({
  declarations: [...components],
  imports: [AideModule, VendorsModule, PipesModule, FormsModule],
  exports: [...components],
  providers: [ProgressionService],
})
export class ComponentsModule {}
